import GetReportResultsRequest from "../../models/serviceModels/GetReportResultsRequest";

export const REPORT_KEYS = {
  all: ["reports"] as const,
  metadata: ["reports", "metadata"] as const,
  activeRefreshes: ["reports", "activeRefreshes"] as const,
  
  // Builder/Report level
  detail: (reportId: string) => ["reports", reportId] as const,
  definition: (reportId: string) => ["reports", reportId, "definition"] as const,
  results: (reportId: string, params: GetReportResultsRequest) => ["reports", reportId, "results", params] as const,
  summary: (reportId: string) => ["reports", reportId, "summary"] as const,
  staleness: (reportId: string) => ["reports", reportId, "staleness"] as const,

  // Dashboard/Group level
  groups: ["groups"] as const,
  groupReports: (groupId: string) => ["groups", groupId, "reports"] as const,
  dashboard: (groupId: string) => ["groups", groupId, "dashboard"] as const,
  groupFilters: (groupId: string) => ["groups", groupId, "filters"] as const,
};

export const isValidReportId = (id?: string | null): boolean => {
  if (!id) return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
};
